// Production-safe console logger. Suppresses console.error in production
// to prevent leaking stack traces and internal state to browser DevTools.

const isProd = typeof import.meta !== 'undefined' && import.meta.env?.PROD;

export const safeLog = {
  error: (...args: unknown[]) => {
    if (!isProd) console.error(...args);
  },
  warn: (...args: unknown[]) => {
    if (!isProd) console.warn(...args);
  },
};
